module.exports = __webpack_public_path__ + "img/menu-item-1 2.472cac0e.svg";